import { E as EVENTS } from "./events-58bc9098.js";
import { addToCart, setButtonLoading, parseFreeGifts } from "./cart-utils.js";

class CrossSells extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();

    this.addEventListener(
      "click",
      (e) => {
        const trigger =
          e.target.closest(".cross-sells-item__add-button") ||
          e.target.closest(".product-item-minimal__content-secondary");
        if (!trigger) return;

        const item = trigger.closest("[js-cross-sells-item]");
        if (!item) return;

        const cta = item.querySelector(".cross-sells-item__add-button");
        if (!cta) return;
        const variantId =
          item?.getAttribute("data-variant-id") || cta.getAttribute("data-variant-id") || "";

        const sellingPlanId =
          item?.dataset.sellingPlanId || cta?.dataset.sellingPlanId || "";

        const freeGifts = parseFreeGifts(item);

        if (!variantId) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        if (cta.dataset.loading === "1") return;

        setButtonLoading(cta, true);

        const stop = () => {
          document.removeEventListener(EVENTS.CART_CHANGED, onCartChange, true);
          clearTimeout(fallbackTimer);
          setButtonLoading(cta, false);
        };

        const onCartChange = () => stop();

        document.addEventListener(EVENTS.CART_CHANGED, onCartChange, true);
        const fallbackTimer = window.setTimeout(() => stop(), 8000);

        addToCart(variantId, 1, sellingPlanId || undefined, this, { freeGifts })
          .then(() => {})
          .catch(() => stop());
      },
      { capture: true, signal: this.abortController.signal }
    );
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }
}

if (!customElements.get("cross-sells")) {
  customElements.define("cross-sells", CrossSells);
}